module.exports = __webpack_public_path__ + "static/media/MFS100_ERROR.2c353da1.png";